import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import LogoWhiteStaging from '@/assets/images/kk-staging-logo.png';
import LogoWhiteProduction from '@/assets/images/kk-prod-logo.png';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';
import { resetFilters } from '@/features/filters/filtersSlice';
import usePreviousRoute from '@/hooks/usePreviousRoute';
import ProfileDropdown from '@/components/ProfileDropdown';
import './Navbar.scss';

interface NavbarProps {
  isSidebarCollapsed: boolean;
  onSidebarToggle: () => void;
}

const CustomNavBar: React.FC<NavbarProps> = ({ isSidebarCollapsed, onSidebarToggle }) => {
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const previousRoute = usePreviousRoute();

  React.useEffect(() => {
    if(previousRoute) {
      dispatch(resetFilters())
    }
  }, [previousRoute, dispatch]);

  const renderLogo = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'staging':
        return LogoWhiteStaging;
      case 'production':
        return LogoWhiteProduction;
      default:
        return LogoWhiteStaging;
    }
  };

  return (
    <Navbar className='krosskast-navbar fixed-top'>
      <Container fluid className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <button className="navbar-toggle" onClick={onSidebarToggle} aria-label="Toggle sidebar">
            <div className={`hamburger-icon${isSidebarCollapsed ? ' collapsed' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
          <img
            src={renderLogo()}
            alt="KrossKast Logo"
            className="navbar-logo ms-2"
            width={140}
            height={44}
            style={{ transition: 'none' }}
          />
        </div>
        {user && (
          <Nav className="ms-auto align-items-center">
            <ProfileDropdown />
          </Nav>
        )}
      </Container>
    </Navbar>
  );
}

export default CustomNavBar;